import React from 'react';
import { NavLink } from 'react-router-dom';
import './SiteNavLink.css';

const SiteNavLink = ({ children, destination, isHLeftAligned = false }) => {
  return (
    <NavLink
      to={destination}
      style={{
        justifyContent: isHLeftAligned ? 'flex-start' : null,
      }}
      className={({ isActive }) =>
        ['nav-link', isActive ? 'site-nav-link-active' : ''].join(' ')
      }
    >
      {children}
    </NavLink>
  );
};

export default SiteNavLink;
